<div class="paginator">
  <div class="paginator__info">
    <select
      class="paginator__select"
      [ngModel]="recordsPerPage"
      (ngModelChange)="recordsPerPage = $event; onRecordsPerPageChange()"
      aria-label="Registros por página"
    >
      @for (opt of recordsPerPageOptions; track opt) {
        <option [value]="opt">{{ opt }}</option>
      }
    </select>
    <span class="paginator__text">{{ getPaginationInfo() }}</span>
  </div>
  <div class="paginator__nav">
    <ul class="paginator__list">
      <li class="paginator__item" [class.paginator__item--disabled]="currentPage === 1">
        <button
          type="button"
          class="paginator__link"
          [disabled]="currentPage === 1"
          (click)="navigateTo(currentPage - 1)"
          aria-label="Anterior"
        >
          ‹
        </button>
      </li>
      @for (p of pages; track p) {
        <li
          class="paginator__item"
          [class.paginator__item--active]="p === currentPage"
          [class.paginator__item--ellipsis]="p === '...'"
        >
          @if (p === '...') {
            <span class="paginator__ellipsis">…</span>
          } @else {
            <button
              type="button"
              class="paginator__link"
              (click)="navigateTo(p)"
              [attr.aria-label]="'Página ' + p"
              [attr.aria-current]="p === currentPage ? 'page' : null"
            >
              {{ p }}
            </button>
          }
        </li>
      }
      <li
        class="paginator__item"
        [class.paginator__item--disabled]="currentPage === totalPages || totalPages === 0"
      >
        <button
          type="button"
          class="paginator__link"
          [disabled]="currentPage === totalPages || totalPages === 0"
          (click)="navigateTo(currentPage + 1)"
          aria-label="Próximo"
        >
          ›
        </button>
      </li>
    </ul>
  </div>
</div>
